import { LeafletMap, Marker } from './LeafletMap'

export type SingleMarkerMapProps = Marker & {
  zoom?: number
  height?: string
}

export const SingleMarkerMap = ({
  lat,
  long,
  marker,
  zoom,
  height,
}: SingleMarkerMapProps) => {
  return (
    <LeafletMap
      markers={[{ lat, long, marker }]}
      zoom={zoom}
      height={height}
    />
  )
}
